import { render, staticRenderFns } from "./soil-type-echarts-header.vue?vue&type=template&id=70416c3b&scoped=true&"
import script from "./soil-type-echarts-header.vue?vue&type=script&lang=js&"
export * from "./soil-type-echarts-header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70416c3b",
  null
  
)

export default component.exports